export default __webpack_public_path__ + "images/e62da3fe4738d6a764eac27679cc05a8.svg";